import React from 'react';
import PropTypes from 'prop-types';

import {connectAppEnv} from '../app-env';
import {OEVersion} from '../../react-oe/oe-version';
import AppInterfaceThieme from './app-interface-thieme';

export function AppInterfaceFactory(props) {
    let version = props.version;

    if(version === OEVersion.thieme)    {
        return <AppInterfaceThieme {...props}/>
    }

    return null;
}

AppInterfaceFactory.defaultProps = {
    moduleId: '',
    version: ''
};

AppInterfaceFactory.propTypes = {
    moduleId: PropTypes.string,
    version: PropTypes.string
};

export default connectAppEnv((env) => { return {
    version: env.config.version,
    appComponent: env.component
}})(AppInterfaceFactory);